import { SvgIcon } from '@mui/material'

export function CheckBoxOutlineBlankIcon(props) {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" fill="#E8E8E8" />
      <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" fill="none" />
    </SvgIcon>
  )
}
